import React from "react";
import { cn } from "../../utils/cn";

export interface FooterProps {
  className?: string;
}

const Footer: React.FC<FooterProps> = ({ className }) => {
  return (
    <footer
      className={cn(
        "w-full border-t border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 py-4 px-6 flex flex-col md:flex-row items-center justify-between text-sm text-gray-500 dark:text-gray-400",
        className,
      )}
      role="contentinfo"
    >
      <div className="mb-2 md:mb-0">
        &copy; {new Date().getFullYear()} CRM System. All rights reserved.
      </div>
      {/* <div className="flex gap-4">
        {getStaticPagesByCategory('legal').slice(0, 2).map((page) => (
          <Link
            key={page.id}
            to={page.path}
            className="hover:text-blue-600 transition-colors"
          >
            {page.title}
          </Link>
        ))}
        {getStaticPagesByCategory('support').slice(0, 1).map((page) => (
          <Link
            key={page.id}
            to={page.path}
            className="hover:text-blue-600 transition-colors"
          >
            {page.title}
          </Link>
        ))}
      </div> */}
    </footer>
  );
};

export default Footer;
